module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/transactions.json
// module id = 389
// module chunks = 237420327260117